import script from "./LongInsureDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./LongInsureDispatchDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./LongInsureDispatchDrawer.vue?vue&type=style&index=0&id=0cc4f718&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc4f718"]])

export default __exports__